
<div  *ngIf="!urlCheck && !validaionMissions">
    <div class="header bg-white">
        <div class="p-px-24">
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active header fs-24 fw-7 text-primary" aria-current="page">Missions</li>
    </ol>
  </nav>
        </div>
    </div>
<div class="missions-container bg-white">
    <mat-tab-group mat-stretch-tabs="{{false}}" mat-align-tabs="start" color="primary">
        <mat-tab label="En cours">
            <app-encour-component></app-encour-component>
        </mat-tab>
        <mat-tab label="Terminées">
            <app-historique-component></app-historique-component>
         </mat-tab>
    </mat-tab-group>
</div>
</div>

<router-outlet >
</router-outlet>
